import axios from 'axios';
import store from '../../store/index';

export default {
	list(deleted = true) {
		return axios.get(`/api/user-groups?deleted=${deleted}`);
	},
	create(userGroup, userIDs) {
		if (userGroup.isSmartUserGroup) {
			return axios.post(`/api/user-groups`, {
				name: userGroup.name,
				description: userGroup.description,
				isSmartUserGroup: userGroup.isSmartUserGroup,
				criteria: userGroup.criteria,
			});
		}
		return axios.post(`/api/user-groups`, {
			name: userGroup.name,
			description: userGroup.description,
			users: userIDs,
			isSmartUserGroup: userGroup.isSmartUserGroup,
		});
	},
	update(userGroup, userIDs) {
		if (userGroup.isSmartUserGroup) {
			return axios.patch(`/api/user-groups/${userGroup.id}`, {
				name: userGroup.name,
				description: userGroup.description,
				criteria: userGroup.criteria,
				deleted: userGroup.deleted,
			});
		}
		return axios.patch(`/api/user-groups/${userGroup.id}`, {
			name: userGroup.name,
			description: userGroup.description,
			deleted: userGroup.deleted,
			...(userIDs !== undefined && { users: userIDs }),
		});
	},
	delete(groupId) {
		return axios.delete(`/api/user-groups/${groupId}`);
	},
};
